export const APP_DATA_VERSION = '1.0.4';
